import type { HeroV2Content, HeroV2CtaType } from "../types/HeroV2Types";

export const filterCtas = (ctas: HeroV2CtaType[] | undefined, isLoggedIn: boolean): HeroV2CtaType[] => {
  if (!ctas) return [];
  return ctas.filter((cta: HeroV2CtaType) => {
    switch (cta.additionalBehavior) {
      case null:
        return true;
      case "onlyForLoggedIn":
        return isLoggedIn;
      case "onlyForNotLoggedIn":
        return !isLoggedIn;
      case "always":
        return true;
      default:
        return false;
    }
  });
};

export const buildHeroContent = (slide: HeroV2Content, isLoggedIn: boolean, isContainerWidth = false) => {
  const gradientPosition = slide.gradientPosition || (slide.hasGradientLeft ? "left" : "top");
  return {
    title: isLoggedIn && slide.content.titleLogged ? slide.content.titleLogged : slide.content.title,
    subheadline:
      isLoggedIn && slide.content.subheadlineLogged ? slide.content.subheadlineLogged : slide.content.subheadline,
    isH1TagDisabled: slide.content.isH1TagDisabled ?? false,
    text: isLoggedIn && slide.content.textLogged ? slide.content.textLogged : slide.content.text,
    logo: slide.logo,
    logoWidth: slide.logoWidth,
    logoHeight: slide.logoHeight,
    logoAlt: slide.logoAlt,
    discounts: slide.content.discounts,
    tagLine: slide.content.tagLine,
    legalDisclaimer: slide.legalDisclaimer,
    displayScrollBar: slide.displayScrollBar,
    cta: filterCtas(slide.content.cta, isLoggedIn),
    isViewportHeight: slide.isViewportHeight ?? true,
    isContainerWidth: isContainerWidth ?? false,
    gradientPosition,
    gradientPositionTablet: slide.gradientPositionTablet,
    gradientPositionMobile: slide.gradientPositionMobile,
    isHeroCardsShown: slide.content.cards && slide.content.cards.length > 1,
    renderImage: slide.renderImage,
    logoReference: slide.logoReference,
    withBreadcrumbs: slide.withBreadcrumbs,
    theme: slide.theme,
  };
};
